import {Col, Row} from "react-bootstrap";
import {loadLocalAssets} from "utils/loader";

export const ArticleItem = ({item, onDelete, isDeleting}) => {
	const removeImagesFromContent = htmlContent => {
		const parser = new DOMParser();
		const doc = parser.parseFromString(htmlContent, "text/html");

		// Remove all <img> elements
		const images = doc.querySelectorAll("img");

		images.forEach(img => img.remove());

		return doc.body.innerHTML;
	};

	const cleanContent = removeImagesFromContent(item.content);

	return (
		<div className="article-post box-grey d-flex flex-column p-3 gap-4 position-relative">
			{onDelete ? (
				<button
					aria-label="Hapus artikel"
					className="btn btn-red d-flex align-items-center gap-2 position-absolute top-0 end-0 m-2 py-1 px-2"
					disabled={isDeleting}
					style={{zIndex: 2}}
					type="button"
					onClick={onDelete}>
					<span className="icon-ico-delete" />
					<span className="d-none d-md-inline">Hapus</span>
				</button>
			) : null}
			<div className="d-flex align-items-center gap-2">
				{item.user.profilePhoto ? (
					<img alt="" className="article-post-profile-picture" src={item.user.profilePhoto} />
				) : (
					<img
						alt=""
						className="article-post-profile-picture"
						src={loadLocalAssets("img/default_avatar.png")}
					/>
				)}

				<div className="d-flex flex-column">
					<span className="text-green fw-semibold">{item.user.firstName}</span>
					<div className="fw-medium">{item.publishDate}</div>
				</div>
			</div>
			<Row>
				<Col md={6}>
					<img alt={item.title} className="w-100 article-post-thumbnail" src={item.thumbnail} />
				</Col>
				<Col className="d-flex flex-column gap-0" md={6}>
					<span className="text-green fw-semibold  m-0">{item.title}</span>

					<div dangerouslySetInnerHTML={{__html: cleanContent}} className="article-post-content" />
				</Col>
			</Row>
		</div>
	);
};
